import { jsx as l } from "react/jsx-runtime";
import p from "../context.js";
import f from "./Item.js";
import { Container as u } from "./styled.js";
const F = ({ name: r, config: s }) => {
  const { uploadyContext: c, field: d, helpers: i } = p(r), { value: t } = d, a = (n) => {
    c.abort(n);
    const e = t.findIndex((o) => o.id === n);
    e !== -1 && i.setValue([...t.slice(0, e), ...t.slice(e + 1)]);
  }, m = (n) => {
    const e = t.findIndex((o) => o.id === n);
    e !== -1 && (async () => (s.deleteFile && await s.deleteFile(n), i.setValue([...t.slice(0, e), ...t.slice(e + 1)])))();
  };
  return /* @__PURE__ */ l(u, { children: t.map((n, e) => /* @__PURE__ */ l(f, { ...n, index: e, onRemove: m, onCancel: a }, n.id)) });
};
export {
  F as default
};
